import { TransactionError } from "ecloud-base-connector";
import { ImportResult } from "@model";
import { BaseResource } from "./_base.resource";
import { TIntegrationRunTypes } from "@types";

export class ImportResource extends BaseResource<ImportResult> {
	public modelName = "ecloudintegrations";

	public parse(modelData: any): ImportResult {
		return new ImportResult(modelData);
	}

	public async run(integrationCode: string, integrationData: any, runType: TIntegrationRunTypes = TIntegrationRunTypes.importNow): Promise<ImportResult> {
		try {
			const uri = `/rest/V1/${this.modelName}/import/${runType}/${integrationCode}`;
			const response = await this.post(uri, { body: { data: integrationData } });
			return this.parse(response);
		} catch (error) {
			const errorMessage = `Error runngin ${integrationCode} integration`;
			this.logger.error(errorMessage, error);
			return Promise.reject(new TransactionError(error, errorMessage));
		}
	}
}